import { Box, Typography } from '@mui/material'

import CloudflareImage from '@ecm/ui/element/CloudflareImage'

type FlowFrameProps = {
  children: string
  heading?: string
  icon: string
  index: number
}

export const FlowFrame = ({ children, heading, icon, index }: FlowFrameProps) => {
  const iconColumns = `${3 * index - 1} / span 1`
  const textColumns = `${1 + 3 * (index - 1)} / span 3`
  return (
    <>
      <Box gridColumn={{ md: iconColumns, xs: 1 }} gridRow={{ md: 1, xs: 3 * index - 2 }}>
        <CloudflareImage src={`/images/icon/${icon}.svg`} width={128} height={128} />
      </Box>
      {heading && (
        <Typography
          variant="h5"
          component="h3"
          sx={{
            gridColumn: { md: textColumns, xs: 1 },
            gridRow: { md: 2, xs: `${3 * index - 1}` },
          }}
          pt="1em"
          pr={{ md: '0.5em', xs: '0' }}
        >
          {heading}
        </Typography>
      )}
      <Typography
        variant="p2"
        m={{ md: '0.5em 1em 3em 0', xs: '0.5em 0 3em' }}
        maxWidth="25em"
        sx={{
          gridColumn: { md: textColumns, xs: 1 },
          gridRow: { md: '3', xs: `${3 * index}` },
        }}
      >
        {children}
      </Typography>
    </>
  )
}

type FlowConnectorProps = {
  icon: string
  index: number
  margin?: string
  width?: string
}

export const FlowConnector = ({ icon, index, margin, width }: FlowConnectorProps) => (
  <Box
    margin={margin}
    display={{ md: 'initial', xs: 'none' }}
    width={width ?? '100%'}
    height="100%"
    gridColumn={`${3 * index} / span 2`}
    gridRow="1"
    position="relative"
  >
    <CloudflareImage src={`/images/icon/${icon}.svg`} layout="fill" />
  </Box>
)

type FlowGridProps = {
  children: React.ReactNode
  frameCount: number
}

export const FlowGrid = ({ children, frameCount }: FlowGridProps) => (
  <Box
    sx={{
      alignItems: 'start',
      display: 'grid',
      gridTemplateColumns: { md: `repeat(${frameCount * 3}, 1fr)`, sm: '1fr' },
      gridTemplateRows: 'auto',
      justifyItems: { md: 'start', sm: 'center' },
    }}
  >
    {children}
  </Box>
)
